import { GENERATE_CHECKBOOK, GET_CHECKBOOK, GET_CHECKBOOK_CHARGE, GET_CHECKBOOK_ENDORSMENT } from './../constants';
import { handleActions } from "redux-actions"

export const checkbook  = handleActions(
  {
    [ GET_CHECKBOOK ]: (state, action) =>[ ...action.payload ],
    [ GENERATE_CHECKBOOK ]: (state, action) =>[...state,  action.payload ],
    [ GET_CHECKBOOK_CHARGE ]: (state, action) =>{
      const result  = action.payload
      const { data } = result
      const checkbookArray  = state
      const initialValue = []
      const newCheckbook = checkbookArray.reduce((acc, checkbook) => {
          if (checkbook.id === data.id) {
            // console.log(checkbook.id +  ' con ' + data.id)
              return [...acc, data]
          } else {
              return [...acc, checkbook]
          }
      }, initialValue)
      return newCheckbook
    },
    [ GET_CHECKBOOK_ENDORSMENT ]: (state, action) => {
        // console.log('update ', action.payload)
        const result  = action.payload
        const { data } = result
        const checkbookArray  = state
        const initialValue = []
        const newCheckbook = checkbookArray.reduce((acc, checkbook) => {
            if (checkbook.id === data.id) {
              // console.log(checkbook.id +  ' con ' + data.id)
                return [...acc, data]
            } else {
                return [...acc, checkbook]
            }
        }, initialValue)
        return newCheckbook
    },
  }, []
)